import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { MouseCatcherContainer as MouseCatcher } from '../util/MouseCatcher';
import { appActions } from '../reducer/app-reducer';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';

export class SetLocaleAndRedirect extends PureComponent {
  constructor(props) {
    super(props);
    // update the current locale based on query string
    const queryParams = window.location.hash.split('/locale/');
    this.handleInterfaceLanguageSelected(queryParams[1]);
  }
  handleInterfaceLanguageSelected = (languageValue) => {
    this.props.setInterfaceLanguage(languageValue);
  };

  render = () => {
    return (
      <div>
        <MouseCatcher />
        <Redirect to="/login" />
      </div>
    );
  };
}

SetLocaleAndRedirect.propTypes = {
  setInterfaceLanguage: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownprops) => ({});

const wrappedActions = { setInterfaceLanguage: appActions.setInterfaceLanguage };

export const SetLocaleAndRedirectContainer = connect(
  mapStateToProps,
  wrappedActions
)(SetLocaleAndRedirect);



// WEBPACK FOOTER //
// ./src/modules/app/components/SetLocaleAndRedirect.jsx